<template>
  <div id="lendRecord-view">
    <p class="accomplish">出借记录</p>
    <div class="clearfix checkBox">
      <span class="demonstration fl">项目类型：</span>
      <el-radio-group v-model="filter.bidType" @change = "filterChange('bidType')">
        <el-radio :label="''">全部</el-radio>
        <el-radio :label="1">直投</el-radio>
        <el-radio :label="2">债转</el-radio>
      </el-radio-group>
    </div>
    <div class="clearfix checkBox" style="margin-top: 14px;">
      <span class="demonstration fl">项目状态：</span>
      <el-radio-group v-model="filter.status" @change="filterChange('status')">
        <el-radio :label="''">全部</el-radio>
        <el-radio :label="3" v-show="filter.bidType !== 2">投标中</el-radio>
        <el-radio :label="4" v-show="filter.bidType !== 2">已满标</el-radio>
        <el-radio :label="6">还款中</el-radio>
        <el-radio :label="5">已转让</el-radio>
        <el-radio :label="7">已完成</el-radio>
        <el-radio :label="8">逾期转让</el-radio>
      </el-radio-group>
    </div>
    <div class="block timeBox">
      <span class="demonstration">到期日期：</span>
      <el-date-picker
        :clearable = false
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change = 'timeChange'>
      </el-date-picker>
    </div>
    <div class="tabBox">
      <el-table
        :row-class-name = "tablecellClassName"
        :data="data"
        style="width: 100%"
        empty-text="当前数据没有，请添加数据">
        <el-table-column
          width="60"
          label="项目类型">
          <template slot-scope="scope">
            <span>{{ scope.row.bidType === 1 ? '直投' : '债转' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="190"
          label="项目名称">
          <template slot-scope="scope">
            <span :title="scope.row.proName">{{ scope.row.proName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="60"
          label="项目期限">
          <template slot-scope="scope">
            <span>{{ dayfu(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="85"
          label="到期日期">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.endDate).format('yyyy-MM-dd') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="90"
          label="出借金额">
          <template slot-scope="scope">
            <span>{{ fmoney(scope.row.bidAmount, 2) }}</span>
          </template>
        </el-table-column>
         <el-table-column
          width="90"
          label="试算回报">
          <template slot-scope="scope">
            <span>{{ fmoney(scope.row.rateAmount, 2) }}</span>
          </template>
        </el-table-column>
         <el-table-column
          width="90"
          label="实际回报">
          <template slot-scope="scope">
            <span>{{ scope.row.bidStatus === 5 || scope.row.bidStatus === 7 ? fmoney(scope.row.realRateAmount, 2) : '--' }}</span>
          </template>
        </el-table-column>
         <el-table-column
          width="60"
          label="项目状态">
          <template slot-scope="scope">
            <span>{{ loanStatus(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button @click="seehandleClick(scope.row)" v-show="scope.row.bidStatus !== 4 && scope.row.proStatus !== 10 && scope.row.proStatus !== 11" type="text">查看</el-button>
          </template>
        </el-table-column>
        <div slot="empty">
          <div class="emptyBox"></div>
          <p style="color:#5e5e5e;">您暂无出借记录！</p>
        </div>
      </el-table>
    </div>
    <div class="block paginationDiv" v-if="page.total!==0">
      <div>
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page = page.page
          :total=page.total>
        </el-pagination>
      </div>
      <div class="total">共{{page.total}}条</div>
    </div>
  </div>
</template>

<script>
export default{
  data () {
    return {
      data: [],
      filter: {
        bidType: '',
        status: '',
        endDate: '',
        startDate: ''
      },
      time: '',
      page: {
        page: 1,
        total: 0
      }
    }
  },
  mounted () {
    this.verifyLogin().then((res) => {
      this.$_init()
    }).catch(() => {
      this.$router.replace({
        path: '/index.htm'
      })
    })
  },
  methods: {
    $_init () {
      this.getData()
    },
    tablecellClassName ({row, rowIndex}) {
      if (row.addDays) {
        if (!(row.addDays < 1)) {
          // 延期
          return 'yellowclass'
        } else if (row.addDays < 0) {
          return 'greenclass'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    filterChange (field) {
      this.page.page = 1
      if (this.filter.bidType === 2 && field === 'bidType') {
        this.filter.status = ''
      }
      this.getData()
    },
    timeChange (value) {
      if (value) {
        this.filter.endDate = new Date(new Date(value[1]).format('yyyy-MM-dd')).toGMTString()
        this.filter.startDate = new Date(new Date(value[0]).format('yyyy-MM-dd')).toGMTString()
      } else {
        this.filter.startDate = null
        this.filter.endDate = null
      }
      this.getData()
    },
    dayfu (item) {
      if (item.addDays) {
        if (!(item.addDays < 1)) {
          // 延期
          return item.proDeadLine + '天+' + item.addDays
        } else if (item.addDays < 0) {
          return item.proDeadLine + '天' + item.addDays
        } else {
          return item.proDeadLine + '天'
        }
      } else {
        return item.proDeadLine + '天'
      }
    },
    getData () {
      var params = {
        page: this.page.page,
        rows: 10
      }
      for (let i in this.filter) {
        if (this.filter[i]) {
          params[i] = this.filter[i]
        }
      }
      this.axios({
        url: this.HOST + '/web-server/account/v1/getCustUserLoanList',
        method: 'GET',
        params: params,
        data: {},
        transformRequest: [(data, headers) => {
          return this.$qs.stringify(data)
        }],
        transformResponse: [(data, headers) => {
          return JSON.parse(data)
        }]
      }).then((res) => {
        // console.log(res.data.data.loanList.list)
        if (res.data.data.code === 1) {
          res.data.data.loanList.list.forEach(function (item) {
            var days = 0
            if (item.payDate && item.realPayDate) {
              days = parseInt((item.realPayDate - item.payDate) / 86400000)
              item.addDays = days
            }
          })
          this.data = res.data.data.loanList.list
          this.page.total = res.data.data.loanList.total
        } else {
          this.$message.error(res.data.data.msg)
        }
      }).catch((res) => {
        this.$message.error('查询失败，请重新尝试！')
      })
    },
    handleCurrentChange (val) {
      this.page.page = val
      this.getData()
    },
    loanStatus (item) {
    	console.log(item.advancepaystatus)
    	if (this.filter.status == 7 && item.advancepaystatus == 1) {
    		return '已垫付'
    	} else {
    		if (item.proStatus === 10 || item.proStatus === 11) {
    		  return item.proStatus === 10 ? '已流标' : '已撤标'
    		} else {
    		  switch (item.bidStatus) {
    		    case 3:
    		      return '投标中'
    		    case 4:
    		      return '已满标'
    		    case 5:
    		      return '已转让'
    		    case 6:
    		      return '还款中'
    		    case 7:
    		      return '已完成'
    		    case 8:
    		      return '已逾期'
    		  }
    		}
    	}
    },
    seehandleClick (row) {
      if (row.bidStatus === 3) {
        this.$router.push({
          path: '/invest/loanDetail.htm',
          query: {
            id: row.proId
          }
        })
      } else if (row.bidStatus !== 3 && row.bidStatus !== 4 && row.proStatus !== 10 && row.proStatus !== 11) {
        this.$router.push({
          path: 'lendRecordDetail',
          query: {
            id: row.id,
            proId: row.proId,
            status: row.bidStatus + ''
          }
        })
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less">
@import url("../../assets/css/accountTotal/lendRecord.less");
#lendRecord-view{
  width: 1010px;
  background: #fff;
  /*padding: 0px 40px;*/
}
</style>



// WEBPACK FOOTER //
// src/page/accountTotal/lendRecord.vue